import styled from 'styled-components'
import { Button, themeColor, themeFontSize, themeFontWeight } from '@elparking/components'

export const FilterNumber = styled.span`
    margin-left: 0.5em;
    height: 18px;
    width: 18px;
    display: inline-block;
    font-size: ${themeFontSize('small')};
    font-weight: ${themeFontWeight('book')};
    background: ${themeColor('accent')};
    color: ${themeColor('gray')};
    border-radius: 50%;
`

export const ButtonRounded = styled(Button)`
    border: 1px solid ${({selected}) => selected ? themeColor('main') : themeColor('gray')};
    color: ${({selected}) => selected ? themeColor('white') : themeColor('gray')};
    background-color: ${({selected}) => selected ? themeColor('main') : themeColor('lightGray20')};
`
